export var DEFAULT_ICON_SIZE = 16;